import { motion } from 'framer-motion'
import { Github, Linkedin, Mail, ArrowUp } from 'lucide-react'
import { personalInfo } from '../data/portfolioData'

export default function Footer({ onNavigate }) {
  return (
    <footer className="bg-[#111111] py-12 px-4 sm:px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">

          <div>
            <button onClick={() => onNavigate('hero')}
              className="font-mono text-sm font-semibold tracking-[0.15em] text-white hover:text-[#0047AB] transition-colors duration-200 mb-3 flex items-center gap-1.5">
              <span className="text-[#0047AB]">›</span> AR
            </button>
            <p className="font-body text-sm text-white/40 max-w-xs">
              IT Support & Implementation Specialist. Melbourne, Australia.
            </p>
          </div>

          <nav className="flex flex-wrap gap-6" aria-label="Footer navigation">
            {['about', 'timeline', 'work', 'skills', 'contact'].map(id => (
              <button key={id} onClick={() => onNavigate(id)}
                className="font-mono text-xs uppercase tracking-wider text-white/40 hover:text-white transition-colors duration-200 capitalize">
                {id}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub"
              className="p-2.5 border border-white/10 rounded-xl hover:border-[#0047AB]/50 hover:bg-[#0047AB]/10 transition-all duration-200">
              <Github size={14} className="text-white/50" />
            </a>
            <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
              className="p-2.5 border border-white/10 rounded-xl hover:border-[#0047AB]/50 hover:bg-[#0047AB]/10 transition-all duration-200">
              <Linkedin size={14} className="text-white/50" />
            </a>
            <a href={`mailto:${personalInfo.emailFallback}`} aria-label="Email"
              className="p-2.5 border border-white/10 rounded-xl hover:border-[#0047AB]/50 hover:bg-[#0047AB]/10 transition-all duration-200">
              <Mail size={14} className="text-white/50" />
            </a>
            <button onClick={() => onNavigate('hero')} aria-label="Back to top"
              className="p-2.5 border border-white/10 rounded-xl hover:border-[#0047AB]/50 hover:bg-[#0047AB]/10 transition-all duration-200">
              <ArrowUp size={14} className="text-white/50" />
            </button>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-white/8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="font-mono text-xs text-white/25">© 2025 Akshay Rao. Built with React + FastAPI.</p>
          <p className="font-mono text-xs text-white/25"><span className="text-[#0047AB]">›</span> Pune · Kuwait · Melbourne</p>
        </div>
      </div>
    </footer>
  )
}
